import "./index.css";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import store from "./store";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FieldProvider } from "@services";
import { RecoilRoot } from "recoil";

const theme = createTheme({
  typography: {
    button: {
      textTransform: "none",
    },
  },
  zIndex: {
    snackbar: 10000,
  },
});

const queryClient = new QueryClient();

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <RecoilRoot>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <FieldProvider>
              <App />
            </FieldProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </RecoilRoot>
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);
